module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-left-square-fill-7f2ae195.svg";